import * as React from 'react';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';
import Coupon from '../../Coupon2';
import { CouponRule, TranslationFn, RULE_TYPES } from '../types';
import { shouldShowShopBtn } from '../utils';
import { SUCCESS_BTN_TEXT_MAP, SPECIAL_COPY_DESC_LOCALES, SPECIAL_SUCCESS_MSG_RULE_TYPES, SHOW_AMOUNT_RULE_TYPES } from '../constants';
import styled from '../index.module.scss';
import styles from './RedeemSuccessModal.module.scss';

interface RedeemSuccessModalProps {
    open: boolean;
    coupon: CouponRule | null;
    locale: string;
    t: TranslationFn;
    onClose: () => void;
    onViewMyRewards: () => void;
    onShopNow: (coupon: CouponRule) => void;
    setCurrNotes: (notes: any) => void;
}

/**
 * RedeemSuccessModal - Modal shown after successful redemption
 */
const RedeemSuccessModal: React.FC<RedeemSuccessModalProps> = ({ open, coupon, locale, t, onClose, onViewMyRewards, onShopNow, setCurrNotes }) => {
    if (!coupon) return null;

    const showShopBtn = shouldShowShopBtn(coupon);
    const successBtnText = SUCCESS_BTN_TEXT_MAP[coupon?.ruleType] || 'store';
    const hideAmount = !SHOW_AMOUNT_RULE_TYPES.includes(coupon?.ruleType as any);
    const showJumpBtn = coupon?.ruleType === RULE_TYPES.THIRD_COUPONS && coupon.useUrl;
    const isSpecialSuccessMsgType = SPECIAL_SUCCESS_MSG_RULE_TYPES.includes(coupon?.ruleType as any);
    const isSpecialCopyDescLocale = SPECIAL_COPY_DESC_LOCALES.includes(locale);

    return (
        <EfModal className={`${styled.efmodal} ${styles.RedeemSuccessModal} coupon`} open={open} visible={open} onCancel={onClose} zIndex={1200}>
            <div className="content">
                <div className="content-left">
                    <Coupon
                        className="coupon-card"
                        coupon={coupon}
                        onViewsRules={setCurrNotes}
                        hideAmount={hideAmount}
                        showJumpBtn={showJumpBtn}
                        hideBtn
                        hideNote
                        modal={true}
                    />
                </div>
                <div className="content-right">
                    <p className="m-desc">{t('redeemed_succ')}</p>

                    {isSpecialSuccessMsgType ? (
                        <p className="m-third-desc">
                            {coupon?.ruleType === RULE_TYPES.THIRD_COUPONS && !isSpecialCopyDescLocale && `${t('copy_desc_2')}, `}
                            {coupon?.ruleType === RULE_TYPES.THIRD_COUPONS && isSpecialCopyDescLocale && `${t('copy_desc_2')} `}
                            <br />
                            {t.rich('grab_success_text2', {
                                code: (children?: string) => (
                                    <i
                                        className="btn"
                                        onClick={() => {
                                            onClose();
                                            onViewMyRewards();
                                        }}
                                    >
                                        {children}
                                    </i>
                                ),
                            })}
                        </p>
                    ) : (
                        <p className="m-desc end">{t('copy_desc')}</p>
                    )}

                    {showShopBtn && (
                        <Button onClick={() => onShopNow(coupon)} className="m-btn">
                            {t(successBtnText)}
                        </Button>
                    )}
                </div>
            </div>
        </EfModal>
    );
};

export default RedeemSuccessModal;
